export const Colors = {
    primary100: "rgba(0,0,0,.75)",
    primary200: "rgba(0,0,2,.3)",
    primary300: "#EEEEEE",
    primary400: "#E0E0E0",
    secondary100: "#e50914",
    secondary200: "#dc3545",
    secondary300: "#000212",
    secondary400: "#000212",
    textPrimary: "white",
    dark100: "black"

}